import {
  Box,
  Container,
  Heading,
  Image,
  Text,
  SimpleGrid,
  Flex,
  HStack,
} from "@chakra-ui/react";
import React from "react";

import sideimage from "../../../assets/about/sideimage.png";
import yellowCircle from "../../../assets/home/ycicrcle.png";
import truck from "../../../assets/home/truck.png";

import FlowerImage from "component/FlowerImage";
import cream from "../../../assets/flower/cream.png";
import blue from "../../../assets/flower/dark blue.png";

const AboutUs = () => {
  return (
    <Box bg="#E8E8E8" pt={8} px={6} position="relative"  overflow="hidden">
      {/* Decorative Flowers */}
      <FlowerImage
        top={{ base: "35%", md: "40%" }}
        src={cream}
        left={{ base: "60%", md: "60%" }}
      />
      <FlowerImage
        src={blue}
        top={{ base: "2%", md: "5%" }}
        left={{ base: "10%", md: "12%" }}
      />

      {/* 🔵 Side Fort Image (Floating Right) */}
      <Image
        src={sideimage}
        alt="Fort Decoration"
        position="absolute"
        right="-40px"
        top={{ base: "80%", md: "50%" }}
        transform="translateY(-50%)"
        width={{ base: "320px", md: "250px", lg: "510px" }}
        zIndex={1}
        display={{ base: "block", md: "block" }}
        
        
      />

      <Container maxW="container.xl" position="relative" zIndex={2}>
        <SimpleGrid
          columns={{ base: 1, md: 2 }}
          spacing={12}
          alignItems="center"
        >
          {/* Left Side - Text + Truck Decoration on Right */}
          <Flex
            direction={{ base: "column", md: "row" }}
            align={{ base: "center", md: "flex-start" }}
            gap={6}
          >
            {/* Left Text Part */}
            <Box flex="1" >
              <HStack>
              <Heading as="h2" fontSize="4xl" fontWeight="bold" color="#0E121A" className="fade-in-up">
                About{" "}
                <Text as="span" fontStyle="italic" color="#BFA585" className="fade-in-up">
                  Us
                </Text>
              </Heading>
              <Box
                position="relative"
                width={{ base: "70px", md: "150px" }}
                height={{ base: "70px", md: "150px" }}
              >
                
                <Image
                  src={yellowCircle}
                  alt="Yellow Circle"
                  position="absolute"
                  top={{ base: "-630%", md: "0%" }}
                  left={{ base: "50%", md: "0" }}
                  width="60%"
                  height="60%"
                  
                />

                {/* 🚚 Truck */}
                <Image
                  src={truck}
                  alt="Truck"
                  position="absolute"
                  top={{ base: "-630%", md: "11%" }}
                  left={{ base: "100%", md: "30%" }}
                  transform="translateX(-50%)"
                  width={{ base: "60px", md: "50px" }}
                  data-animated = 'true'
                  
                />
              </Box>
              </HStack>
              

              <Text fontSize="lg" mt={4} color="black" lineHeight="1.8" className="fade-in-up">
                At Doggle India, we’re redefining digital marketing with a blend
                of creativity and practicality that’s as vibrant as Rajasthan’s
                heritage.
              </Text>
              <Text fontSize="lg" mt={4} color="black" lineHeight="1.8" className="fade-in-up">
                Based in Jaipur, we’re recognized as one of the best digital
                marketing companies in Jaipur and across India. We’re more than
                strategists; we’re your partners in crafting a digital legacy
                that lasts.
              </Text>
            </Box>
          </Flex>
          <Box />
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default AboutUs;
